import { render, staticRenderFns } from "./lbFullyGood.vue?vue&type=template&id=25a946c8&scoped=true&"
import script from "./lbFullyGood.vue?vue&type=script&lang=js&"
export * from "./lbFullyGood.vue?vue&type=script&lang=js&"
import style0 from "./lbFullyGood.vue?vue&type=style&index=0&id=25a946c8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25a946c8",
  null
  
)

export default component.exports